import { createActions, handleActions } from 'redux-actions';

export const types = {
  STORE_IMAGES: 'STORE_IMAGES',
  APPEND_IMAGES: 'APPEND_IMAGES',
  REMOVE_IMAGES: 'REMOVE_IMAGES',

  OPEN_PICTURE_MAGNIFY: 'OPEN_PICTURE_MAGNIFY',
  CLOSE_PICTURE_MAGNIFY: 'CLOSE_PICTURE_MAGNIFY',
};

export const {
  storeImages,
  appendImages,
  removeImages,
  openPictureMagnify,
  closePictureMagnify,
} = createActions(
  {
    [types.STORE_IMAGES]: (images) => ({
      images,
    }),
    [types.APPEND_IMAGES]: (images) => ({
      images,
    }),
    [types.OPEN_PICTURE_MAGNIFY]: (picture) => ({
      picture,
    }),
  },
  types.REMOVE_IMAGES,
  types.CLOSE_PICTURE_MAGNIFY
);

const INIT_STATE = {
  data: [],
  picture: null,
};

export default handleActions(
  {
    [types.STORE_IMAGES]: (state, action) => ({
      ...state,
      data: action.payload.images.reverse(),
    }),
    [types.APPEND_IMAGES]: (state, action) => ({
      ...state,
      data: action.payload.images.concat(state.data),
    }),
    [types.REMOVE_IMAGES]: (state) => ({
      ...state,
      data: [],
    }),
    [types.OPEN_PICTURE_MAGNIFY]: (state, action) => ({
      ...state,
      picture: action.payload.picture,
    }),
    [types.CLOSE_PICTURE_MAGNIFY]: (state) => ({
      ...state,
      picture: null,
    }),
  },
  INIT_STATE
);

export const getImages = (state) => state.chat.images.data;
export const getPicture = (state) => state.chat.images.picture;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/images.js